module.exports = __webpack_public_path__ + "img/addMember.0ac5019b.png";